import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M5.7 2h12.6c2 0 3.7 1.7 3.7 3.7v12.6c0 2-1.7 3.7-3.7 3.7H5.5C3.6 22 2 20.4 2 18.5V5.7C2 3.7 3.7 2 5.7 2zm12.6 2H5.7C4.8 4 4 4.8 4 5.7v8.9l4.3-4.3c.2-.2.5-.3.8-.3.2 0 .5.2.7.4l3.3 4.1 2.2-2.2c.4-.4 1-.4 1.4 0l3.3 3.3V5.7c0-.9-.8-1.7-1.7-1.7zM5.5 20h12.8c.9 0 1.6-.7 1.7-1.6l-4-4-2.3 2.3c-.2.2-.5.3-.8.3-.3 0-.5-.2-.7-.4l-3.3-4.1L4 17.4v1.1c0 .8.7 1.5 1.5 1.5zM17 8c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3zm-2 0c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1z" />,
  'Picture'
)
